"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 24 24" id=icon-attention-filled><path fill=#e62048 fill-rule=evenodd d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.994 5.375 18.625.006 12 0zm0 18a1 1 0 110-2 1 1 0 010 2zm1-5V7a1 1 0 00-2 0v6a1 1 0 002 0z"></path></symbol>';
};